import Vue from 'vue';
import ApiClient from './ApiClient';

export default class BaseAPIClient extends ApiClient {
  constructor($http) {
    super(
      $http,
      Vue.prototype.$globalEnv.baseUrl,
      Vue.prototype.$globalEnv.baseUrlV2
    );
  }
}
